<div class="modal-header">
    <h5 class="modal-title">Bulk Scheduling</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <div class="card">
        <div class="card-body">
            <div class="d-flex flex-column mb-2">
                <div class="form-check my-auto">
                    <input id="BULK_SCHEDULE_FINAL_INVOICE" type="checkbox" class="form-check-input" [checked]=true>
                    <label for="BULK_SCHEDULE_FINAL_INVOICE" class="form-check-label fw-bold">Final Invoice</label>
                    <span class="ms-2" style="cursor: pointer;" ngbPopover="Generate an invoice one day before the schedule date. This will only affect installations that have accepted proposals." triggers="click" placement="right">
                        <fa-icon [icon]="faQuestionCircle"></fa-icon>
                    </span>
                </div>
                <button type="button" class="btn btn-sm btn-primary mt-1" (click)="applyBulkScheduleFinalInvoice();">Apply Final Invoice to All</button>
            </div>
            <div class="d-flex flex-column mb-2">
                <label for="BULK_SCHEDULE_DATE" class="fw-bold my-auto">Date</label>
                <input id="BULK_SCHEDULE_DATE" type="date" class="form-control mt-1">
                <button type="button" class="btn btn-sm btn-primary mt-2" (click)="applyBulkScheduleDate();">Apply Date to All</button>
            </div>
            <div class="d-flex flex-column">
                <label for="BULK_SCHEDULE_USERS" class="fw-bold my-auto">Users</label>
                <div id="BULK_SCHEDULE_USERS" class="mt-1">
                    <ul class="list-group scrollable" style="max-height: 210px;">
                        <li *ngFor="let user of users" class="list-group-item list-group-item-action" style="height: 42px;" (click)="selectBulkUser(user.id);">
                            <div class="d-flex">
                                <div>{{user.firstName}} {{user.lastName}}</div>
                                <fa-icon *ngIf="isBulkUserSelected(user.id);" [icon]="faCheck" class="ms-auto"></fa-icon>
                            </div>
                        </li>
                        <li *ngIf="users.length == 0" class="list-group-item">No Users</li>
                    </ul>
                </div>
                <button type="button" class="btn btn-sm btn-primary mt-2" (click)="applyBulkScheduleUsers();">Apply Users to All</button>
            </div>
        </div>
    </div>
    <div [class.mt-3]="scheduleItems.length > 0">
        <form [formGroup]="bulkScheduleForm">
            <div class="accordion" id="scheduleAccordion">
                <div class="accordion-item" *ngFor="let scheduleItem of scheduleItems">
                  <h2 class="accordion-header" [id]="'heading' + scheduleItem.id">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + scheduleItem.id" aria-expanded="false" [attr.aria-controls]="'collapse' + scheduleItem.id">
                      <div class="d-flex">
                        <div class="d-flex flex-column me-2">
                          <button type="button" class="btn p-0" (click)="$event.stopPropagation(); removeScheduleItem(scheduleItem);">
                            <fa-icon [icon]="faTrashCan"></fa-icon>
                          </button>
                        </div>
                        <fa-icon [icon]="getScheduleItemTypeIcon(scheduleItem.type)" size="lg" class="my-auto ms-2"
                          [style.color]="scheduleItem.crews && scheduleItem.crews.length > 0 ? (scheduleItem.crews[0].crewColor || '#000000') : '#000000'">
                        </fa-icon>
                        <div class="d-flex flex-column ms-3">
                          <strong>{{ scheduleItem.clientName }}</strong>
                          <small class="text-muted">
                            FI: {{ getNestedFormControl(scheduleItem.id, 'generateInvoice').value ? 'Yes' : 'No' }},
                            Date: {{ getNestedFormControl(scheduleItem.id, 'date').value | formatDateTime: getNestedFormControl(scheduleItem.id, 'isAllDay').value }},
                            Users: {{ getUserCount(scheduleItem.id) }}
                          </small>
                        </div>
                      </div>
                    </button>
                  </h2>
                  <div [id]="'collapse' + scheduleItem.id" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading' + scheduleItem.id" data-bs-parent="#scheduleAccordion">
                    <div class="accordion-body">
                      <form [formGroupName]="scheduleItem.id">
                        <!-- Final Invoice Checkbox -->
                        <div *ngIf="scheduleItem.type == 'INSTALL'" class="mb-2">
                          <div class="form-check">
                            <input id="SCHEDULE_ITEM_FINAL_INVOICE_{{scheduleItem.id}}" type="checkbox" class="form-check-input" formControlName="generateInvoice">
                            <label for="SCHEDULE_ITEM_FINAL_INVOICE_{{scheduleItem.id}}" class="form-check-label">Final Invoice</label>
                            <span *ngIf="scheduleItem.acceptedProposalExists" class="ms-2" ngbPopover="Generate an invoice one day before the schedule date." triggers="click" placement="right">
                              <fa-icon [icon]="faQuestionCircle"></fa-icon>
                            </span>
                            <span *ngIf="!scheduleItem.acceptedProposalExists" class="ms-2" ngbPopover="Cannot schedule a final invoice because there is no accepted proposal for this project." triggers="click" placement="right">
                              <fa-icon [icon]="faQuestionCircle" style="opacity: 0.5;"></fa-icon>
                            </span>
                          </div>
                        </div>

                        <!-- Date Input -->
                        <div class="mb-2">
                          <label for="SCHEDULE_ITEM_DATE_{{scheduleItem.id}}">Date</label>
                          <div class="input-group">
                            <input *ngIf="getNestedFormControl(scheduleItem.id, 'isAllDay').value" id="SCHEDULE_ITEM_DATE_{{scheduleItem.id}}" type="date" class="form-control" formControlName="date" required>
                            <input *ngIf="!getNestedFormControl(scheduleItem.id, 'isAllDay').value" id="SCHEDULE_ITEM_DATE_{{scheduleItem.id}}" type="datetime-local" class="form-control" formControlName="date" required>
                            <div class="input-group-text">
                              <div class="form-check mb-0">
                                <input id="SCHEDULE_ITEM_DATE_IS_ALL_DAY_{{scheduleItem.id}}" type="checkbox" class="form-check-input" formControlName="isAllDay" (change)="toggleAllDay(scheduleItem.id);">
                                <label for="SCHEDULE_ITEM_DATE_IS_ALL_DAY_{{scheduleItem.id}}" class="form-check-label">All Day</label>
                              </div>
                            </div>
                          </div>
                          <small *ngIf="scheduleItem.type == 'INSTALL' && scheduleItem.installationWeek" class="text-muted">
                            Preferred Installation Week: {{ scheduleItem.installationWeek | formatDateTime: true }}
                          </small>
                          <small *ngIf="scheduleItem.type == 'REMOVE'" class="text-muted">
                            Preferred Removal Type: {{ scheduleItem.removalType }}
                          </small>
                        </div>

                        <!-- Duration Input -->
                        <div *ngIf="!getNestedFormControl(scheduleItem.id, 'isAllDay').value" class="mb-2">
                          <label for="SCHEDULE_ITEM_DURATION_{{scheduleItem.id}}">Duration</label>
                          <div class="input-group">
                            <input id="SCHEDULE_ITEM_DURATION_{{scheduleItem.id}}" type="number" class="form-control" placeholder="1.50" formControlName="duration" step="0.25">
                            <span class="input-group-text">Hours</span>
                          </div>
                          <small *ngIf="getNestedFormControl(scheduleItem.id, 'date').value" class="text-muted">
                            End: {{ getEndDateTime(scheduleItem.id) }}
                          </small>
                        </div>

                        <!-- Users Selection -->
                        <div class="mb-3">
                          <label for="SCHEDULE_ITEM_USERS_{{scheduleItem.id}}">Users</label>
                          <div id="SCHEDULE_ITEM_USERS_{{scheduleItem.id}}">
                            <ul class="list-group scrollable" style="max-height: 210px;">
                              <li *ngFor="let user of users" class="list-group-item list-group-item-action" (click)="selectUser(scheduleItem.id, user.id);">
                                <div class="d-flex">
                                  <div>{{ user.firstName }} {{ user.lastName }}</div>
                                  <fa-icon *ngIf="isUserSelected(scheduleItem.id, user.id);" [icon]="faCheck" class="ms-auto"></fa-icon>
                                </div>
                              </li>
                              <li *ngIf="users.length == 0" class="list-group-item">No Users</li>
                            </ul>
                          </div>
                        </div>

                        <!-- Notes Input -->
                        <div>
                          <label for="SCHEDULE_ITEM_NOTES_{{scheduleItem.id}}">Notes</label>
                          <textarea id="SCHEDULE_ITEM_NOTES_{{scheduleItem.id}}" class="form-control" formControlName="notes" placeholder="Client would prefer..." rows="2" maxlength="65535"></textarea>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

        </form>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="bulkUpdateScheduleItems();" [disabled]="scheduleItems.length === 0">Save</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Close</button>
</div>
